import PickUp from './pick-up';

export default PickUp;
